import Select from "react-select";
import React from "react";


const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "transparent",
    borderColor: "#3cd2a5",
    color: "#3cd2a5",
    zIndex: 99,
    height: "35px",
    minHeight: "35px", // Important to set both for consistent height
  }),

  valueContainer: (styles) => ({
    ...styles,
    height: "35px",
    minHeight: "35px", // Important to set both for consistent height
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "35px",
  }),

  input: (styles) => ({
    ...styles,
    color: "#3cd2a5",
    "::placeholder": "#3cd2a5",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#3cd2a5",
    fontSize: "13px",
    textAlign: "center",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#3cd2a5",
  }),
};

export default function SearchableFilter({
  onChange,
  value,
  list,
  isMulti = false,
  label = "",
}) {
  return (
    <Select
      isMulti={isMulti}
      closeMenuOnSelect={true}
      isClearable={true}
      placeholder={`- Select ${label} -`}
      isSearchable={true}
      styles={colourStyles}
      options={list.map((i) => {
        return {
          value: i.value,
          label: i.label,
        };
      })}
      value={value}
      onChange={onChange}
    />
  );
}